import React from "react";
import cx from "ui/cx";
import styles from "./HorizontalRule.module.scss";

export default function HorizontalRule({ className, style }: React.HTMLAttributes<HTMLHRElement>) {
  return <hr className={cx(styles.wrapper, className)} style={style} />;
}
